import React, { useState, useEffect } from 'react';
import { withTranslation } from './ChildrenContext.js';
import PropTypes from 'prop-types';
import NotFoundPage from './pages/errors/NotFoundPageShell';
import Loading from './Loading';

const CheckContent = (props) => {
    const [loading, setLoading] = useState(true);
    const [isEmpty, setIsEmpty] = useState(false);

    const staticNames = (props.t && props.t.errorPage && props.t.errorPage.notFoundContent) || {};

    useEffect(() => {
        setLoading(props.loading);
        setIsEmpty(props.isEmpty);
    }, [props.loading, props.isEmpty]);

    return (
        isEmpty && !loading
            ? <NotFoundPage
                showCode={false}
                static={staticNames}
              />
            : loading
                ? <Loading center={true} />
                : props.children
    );
};

export default withTranslation(CheckContent);
